// extracted by css-extract-rspack-plugin
export default {"RefPillOcticon":"RefPill-module__RefPillOcticon__mjmLr","RefPillTruncate":"RefPill-module__RefPillTruncate__BgErF","RefPillText":"RefPill-module__RefPillText__TdcLS"};